/* eslint-disable */
const filterByProductType = {
    all: 'all',
    hotelOffer: 'HotelOfferProduct',
    railwayTour: 'RailwayTourProduct',
    tourOffer: 'TourProduct',
};

const filterToProductType = (filterType: keyof typeof filterByProductType) => filterByProductType[filterType];

export {
    filterToProductType,
};